import { useParams } from 'react-router-dom';
import Panel from '../../../../common/layout/Panel'
import DataResource from '../../../../common/v4/DataResource';

const ClientAccountBilling = () => {
        const { account_id } = useParams();
    const data = {
        url: `/admin/clients/clients/${account_id}/payments`,
        data: {
            data: [],
            metadata: []
        },
        userFilterExpandable: false,
        metadata: [
            {
                source: 'ATRPAYID',
                label: 'ID',
                type: 'primary',
                editable: false,
                visible: false
            },
            {
                source: 'ATRAMNT',
                label: 'Amount',
                type: 'text',
            },
            {
                source: 'ATRCURID',
                label: 'Currency',
                type: 'select',
            },
            {
                source: 'ATRPMNTDESCR',
                label: 'Description',
                type: 'text',
            },
            {
                source: 'ATRREFID',
                label: 'Reference',
                type: 'text',
            },
            {
                source: 'ATRPMNTDATE',
                label: 'Paid At',
                type: 'date',
            },
            {
                source: 'created_at',
                label: 'Posted At',
                type: 'date',
            },
            {
                type: 'delete',
                label: 'Delete',
            }
        ]
    }
    return (
       <Panel title = "Billing">
            <DataResource
                addButtonText = "Create Payment"
                addButtonLink = {`/clients/clients/${account_id}/billing/create`}                    
                data = {data}
            />
        </Panel>
    )
}

export default ClientAccountBilling;